import React from "react";
import { MainModal } from "../../../../components/modal/MainModal";
import Table from "../../../../components/table/coreUiTable/Table";
import useUploadXlsx from "../../../../hooks/useUploadXlsx";
import { adminUsersApi } from "../api";

export const Upload = ({ onClose }) => {
  const { error, file, onFileUpload, request } = useUploadXlsx(adminUsersApi.import);

  const primaryBtnHandler = () => {
    request();
    onClose();
  };

  return (
    <>
      <MainModal
        isOpen
        onClose={onClose}
        parentSelector=".admin-users"
        primaryButtonText="Upload"
        primaryBtnHandler={primaryBtnHandler}
        primaryButtonDisabled={!file}
        secondaryBtnText="Cancel"
        secondaryBtnHandler={onClose}
        width={650}
        height="auto"
        headerCloseHandler={onClose}
        headerText="Import Users"
      >
        <div className="admin-users-upload">
          <div className="admin-upload__info">
            Your <b>XLSX</b> should be in the following format:
          </div>

          <Table
            tableFilter={false}
            table={{
              colHeaders: ["Site ID", "Studio Info", "First Name", "Last Name", "Email", "Role"],
              data: [
                ["1111", "Test Name", "John", "Smith", "test@email.com", "Owner (default)"],
                ["1111", "Test Name", "John", "Smith", "test@email.com", "Owner (default)"],
                ["1111", "Test Name", "John", "Smith", "test@email.com", "Owner (default)"],
                ["1111", "Test Name", "John", "Smith", "test@email.com", "Owner (default)"]
              ]
            }}
          />
        </div>

        <input type="file" accept=".xlsx" placeholder="Choose XLSX file" onChange={onFileUpload} />

        {error && <div className="help-block">* {error}</div>}
      </MainModal>
    </>
  );
};
